module.exports = __webpack_public_path__ + "static/media/24UHCHR20.48f7cd69.jpg";